export default __webpack_public_path__ + "static/media/shared bathroom.465ad536.svg";